// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Rubik", 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* .ant-input, .ant-select-selector {
  height: 35px 
  
} */

/* Additional styling for better alignment */
.ant-select-single .ant-select-selector .ant-select-selection-item {
  line-height: 35px !important;
}

/* Target Ant Design input containers */
.ant-input,
.ant-input-affix-wrapper,
.ant-picker,
.ant-select-selector {
  background-color: #fcfcfc !important; /* Soft grey color */
}

/* Ensure the background color doesn't change on hover or focus */
.ant-input:hover,
.ant-input-affix-wrapper:hover,
.ant-picker:hover,
.ant-select-selector:hover,
.ant-input:focus,
.ant-input-affix-wrapper-focused,
.ant-picker-focused,
.ant-select-selector:focus {
  background-color: #f5f5f5 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;GAGG;;AAEH,4CAA4C;AAC5C;EACE,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;;;;EAIE,oCAAoC,EAAE,oBAAoB;AAC5D;;AAEA,iEAAiE;AACjE;;;;;;;;EAQE,oCAAoC;AACtC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Rubik\", 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* .ant-input, .ant-select-selector {\n  height: 35px \n  \n} */\n\n/* Additional styling for better alignment */\n.ant-select-single .ant-select-selector .ant-select-selection-item {\n  line-height: 35px !important;\n}\n\n/* Target Ant Design input containers */\n.ant-input,\n.ant-input-affix-wrapper,\n.ant-picker,\n.ant-select-selector {\n  background-color: #fcfcfc !important; /* Soft grey color */\n}\n\n/* Ensure the background color doesn't change on hover or focus */\n.ant-input:hover,\n.ant-input-affix-wrapper:hover,\n.ant-picker:hover,\n.ant-select-selector:hover,\n.ant-input:focus,\n.ant-input-affix-wrapper-focused,\n.ant-picker-focused,\n.ant-select-selector:focus {\n  background-color: #f5f5f5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
